<template>
  <div :style="maxHeight" @mousewheel="getMaxHeight" style="overflow: hidden;">
  <div style="width: 100%;height: 50px;">
    <el-form :model="formData" label-width="20px">
      <el-row>
        <el-form-item label="" prop="star">
          <el-select v-model="formData.wujianId" :placeholder="$t('makeSchedule.wujianPlanPage.wujianId')" class="toolbar_item" style="width: 200px" clearable>
            <el-option v-for="dict in wujianNameLlist" :key="dict.value" :label="dict.label" :value="dict.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="" prop="star">
          <el-date-picker v-model="formData.startMonth" format=" YYYY 年 M 月 "  value-format="YYYY-M" type="month" placeholder="开始月份" style="width: 150px; margin-right: 10px" :clearable="false" />
          <span style="margin-right: 10px"> - </span>
          <el-date-picker v-model="formData.endMonth" format=" YYYY 年 M 月 "  value-format="YYYY-M" type="month" placeholder="结束月份" style="width: 150px; margin-right: 10px" :clearable="false" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getPlanAchievementsData" :loading="planAchievementsLoading">搜索</el-button>
        </el-form-item>
        <el-form-item>
          <i class="dotClass" style="background: rgba(255 245 204);border: rgba(255 204 0) solid 1px "></i>
          <span style="margin-left: 10px">{{ $t('makeSchedule.wujianPlanPage.jgPlan') }}</span>
        </el-form-item>
        <el-form-item>
          <i class="dotClass" style="background: rgba(255 204 0)"></i>
          <span style="margin-left: 10px">{{ $t('makeSchedule.wujianPlanPage.jgAchievements') }}</span>
        </el-form-item>
        <el-form-item>
          <i class="dotClass" style="background: rgba(229 181 255);border: rgba(166 0 255) solid 1px "></i>
          <span style="margin-left: 10px">{{ $t('makeSchedule.wujianPlanPage.tzPlan') }}</span>
        </el-form-item>
        <el-form-item>
          <i class="dotClass" style="background: rgba(166 0 255)"></i>
          <span style="margin-left: 10px">{{ $t('makeSchedule.wujianPlanPage.tzAchievements') }}</span>
        </el-form-item>
        <el-form-item>
          <i class="dotClass" style="background: #DBFCC9;border: #94D82D solid 1px "></i>
          <span style="margin-left: 10px">{{ $t('makeSchedule.wujianPlanPage.zlPlan') }}</span>
        </el-form-item>
        <el-form-item>
          <i class="dotClass" style="background:#94D82D"></i>
          <span style="margin-left: 10px">{{ $t('makeSchedule.wujianPlanPage.zlAchievements') }}</span>
        </el-form-item>
      </el-row>

    </el-form>
  </div>
  <div style="width: 100%;height: 90%;">
    <el-table :data="floorData" border :key="tableKey" stripe style="width: 100%;"
              :header-cell-style="{textAlign: 'center'}"
              :cell-style="{ textAlign: 'center', width: '100%',}" height="100%">
      <el-table-column prop="wujian_name" :label="$t('makeSchedule.wujianPlanPage.wujianName')" width="120" fixed/>
      <el-table-column prop="floor" :label="$t('makeSchedule.wujianPlanPage.floor')" width="60" fixed/>
      <el-table-column prop="advance_floor" :label="$t('makeSchedule.wujianPlanPage.xxFloor')" width="80" fixed/>
      <el-table-column prop="balance" :label="$t('makeSchedule.wujianPlanPage.jieyu')" width="60" fixed/>
      <el-table-column prop="weight" :label="$t('makeSchedule.wujianPlanPage.weight')" width="70">
      <template v-slot="scope">
        {{scope.row.weight.toLocaleString()}}
      </template>
      </el-table-column>
      <el-table-column prop="unit_num" :label="$t('makeSchedule.wujianPlanPage.num')" width="60"/>
      <el-table-column prop="area" :label="$t('makeSchedule.wujianPlanPage.area')" width="60">
        <template v-slot="scope">
        {{scope.row.area.toLocaleString()}}
        </template>
      </el-table-column>

      <el-table-column :label="$t('makeSchedule.wujianPlanPage.jgProgress')" width="70">
        <template v-slot="scope">
          <el-progress :text-inside="true" :stroke-width="15" :percentage="scope.row.jg_schedule" :color="customColors" class="yw_left" />
        </template>
      </el-table-column>
      <el-table-column :label="$t('makeSchedule.wujianPlanPage.tzProgress')" width="70">
        <template v-slot="scope">
          <el-progress :text-inside="true" :stroke-width="15" :percentage="scope.row.tz_schedule" :color="customColors" class="yw_left" />
        </template>
      </el-table-column>
      <el-table-column :label="$t('makeSchedule.wujianPlanPage.zlProgress')" width="70">
        <template v-slot="scope">
          <el-progress :text-inside="true" :stroke-width="15" :percentage="scope.row.zl_schedule" :color="customColors" class="yw_left" />
        </template>
      </el-table-column>
      <el-table-column :label="$t('makeSchedule.wujianPlanPage.chProgress')" width="70">
        <template v-slot="scope">
          <el-progress :text-inside="true" :stroke-width="15" :percentage="scope.row.outbound_schedule" :color="customColors" class="yw_left" />
        </template>
      </el-table-column>

      <el-table-column :label="dateList[index].years" v-for="(item,index) in dateList" :key="item.index">
        <el-table-column :label="item.monthList[index].day" v-for="(list,index) in item.monthList" :key="list.date">
          <el-table-column :label="item.monthList[index].week" width="30">
            <template v-slot="scope">
              <div v-for="plannedActual in scope.row.planned_actual" :key="plannedActual.lot">
                <div v-if="item.monthList[index].date == plannedActual.date">
                  <div style="height: 13px">
                    <div v-if="plannedActual.jiagong_plan == null" class="div" style="background: rgba(255 255 255);border:rgba(255 255 255) solid 1px;"></div>
                    <div v-if="plannedActual.jiagong_plan" class="div" style="background: rgba(255 245 204);border:rgba(255 204 0) solid 1px "></div>
                    <div v-if="plannedActual.jiagong_actual" class="div" style="background: rgba(255 204 0);width: 100%;"></div>
                  </div>
                  <div style="height: 13px">
                    <div v-if="plannedActual.tuzhuang_plan == null" class="div" style="background: rgba(255 255 255);border:rgba(255 255 255) solid 1px;"></div>
                    <div v-if="plannedActual.tuzhuang_plan" class="div" style="background: rgba(229 181 255);border:rgba(166 0 255) solid 1px "></div>
                    <div v-if="plannedActual.tuzhuang_actual" class="div" style="background: rgba(166 0 255);"></div>
                  </div>
                  <div style="height: 13px">
                    <div v-if="plannedActual.zuli_plan == null" class="div" style="background: rgba(255 255 255);border:rgba(255 255 255) solid 1px;"></div>
                    <div v-if="plannedActual.zuli_plan" class="div" style="background: #DBFCC9;border: #94D82D solid 1px "></div>
                    <div v-if="plannedActual.zuli_actual" class="div" style="background:#94D82D"></div>
                  </div>

                </div>
              </div>
            </template>
          </el-table-column>
        </el-table-column>
      </el-table-column>
    </el-table>
<!--    <div class="pageStyle">-->
<!--        <el-pagination style="margin-right: 13px" background layout="total, prev, pager, next" :total="total" :current-page="pageNo" @current-change="currentCheckChange" :page-size="10"></el-pagination>-->
<!--    </div>-->
  </div>
  </div>
</template>

<script>
export default {
  name: "MfgWuJianPlan",
  data() {
    return {
      planAchievementsLoading:false,
      total: 0,
      pageNo: 1,
      formData: {
        wujianId: '',
        quarter:'',
        startMonth:this.getDateFormat(),
        endMonth:this.getDateFormat()
      },
      maxHeight:'',
      wujianNameLlist: [],
      floorData: [],
      dateList: [],
      customColors:[
        { color: '#f56c6c', percentage: 20 },
        { color: '#dcf372', percentage: 40 },
        { color: '#c0f08b', percentage: 60 },
        { color: '#9ce17a', percentage: 80 },
        { color: '#67c23a', percentage: 100 },
      ]
    }
  },
  methods: {
    getMaxHeight() {
      let pageHeight = document.body.scrollHeight - 160;
      this.maxHeight = "height: "+pageHeight+"px;";
    },
    getDateFormat(){
      let month = new Date().getMonth() + 1
      return new Date().getUTCFullYear().toString() + "-" + month.toString() + "-1"
    },
    currentCheckChange(pageNo) {
      this.pageNo= pageNo
      this.total = this.floorData.length
    },
    //获取物件名称
    getAllWujianName() {
      this.$axios.post('mfg/wujianPlan/getWujianName',).then(response => {
        let res = response.data
        this.wujianNameLlist = res.data

      }, error => {
        this.$message.error(`获取数据失败` + error.message);
      })
    },
    getPlanAchievementsData(){

      //判断开始时间是否大于结束时间
      let startMonth = Date.parse(new Date(this.formData.startMonth));
      let endMonth = Date.parse(new Date(this.formData.endMonth));
      if (startMonth > endMonth){
        return this.$message.error('开始月份不能大于结束月份！')
      }

      this.planAchievementsLoading = true;
      this.$axios.post('mfg/wujianPlan/getWujianPlanData',this.formData).then(response => {
        let res = response.data
        if (res.code === 0) {
          this.dateList = res.data.dateList
          this.floorData = res.data.floorData
          this.planAchievementsLoading = false;

        }
      }, error => {
        this.$message.error(`获取数据失败` + error.message);
      })
    }

  },
  mounted() {

  },
  created() {
    this.getMaxHeight()
    this.getAllWujianName()
  }
}
</script>

<style scoped>
.dotClass {
  width: 12px;
  height: 12px;
  border: black;
  display: block;
}

.div {
  width: 100%;
  height: 6px;
  margin-top: 1px;
}

.el-table :deep(.cell) {
  padding: 0px;
}

.el-table :deep(.el-table__cell) {
  padding: 0px;
}
.pageStyle{
  width: 100%;
  display: flex;
  justify-content:flex-end;
  margin: 20px 0
}
.yw_left >>>  .el-progress-bar__innerText {
  color: black;
}

</style>